import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { Article } from "../_/components/Article";
import { Ref } from "../_/components/Reference";
import { Gear } from "./Gear";
import { Shields } from "./Shields";
import { Armors } from "./Armors";
import { TableCellFixed } from "../_/components/TableCellFixed";

export const Fight = () => {
    return (
        <>
            <Article.Title>
                Opis miejsca konfliktu
            </Article.Title>
            <Article.Body>
                Przed walką Gap: sam, lub wspólnie z graczami powinien opisać miejsce w którym dochodzi do konfliktu. W trakcie walki możliwe jest powoływanie się na ten opis w celu skupienia lub rozproszenia kości.
            </Article.Body>

            <Article.Title>
                Walka
            </Article.Title>
            <Article.Body>
                Walkę rozpoczyna się od określenia strony zaczynającej zgodnie z opisem <Ref subject="initiative">Inicjatywa</Ref>, następnie walka przebiega w naprzemiennych turach, aż do rozstrycgnięcia walki.
                Jeśli stroną sporu jest drużyna graczy, mogą oni dowolnie ustalić między sobą, kto i w jakiej kolejności wykonuje ruch. W przypadku drużyny postaci niezależnych decyzje te podejmuje <Ref subject="gawker">Gap</Ref>.
            </Article.Body>

            <Article.Title>
                Inicjatywa
            </Article.Title>
            <Article.Body>
                Walkę zawsze zaczynają postacie graczy, chyba że z fikcji jednoznacznie wynika, że nie jest to możliwe np. gdy wpadły one w płuapkę lub są zaskoczeni.
                W Sytuacjach spornych Gap może zarządzić test na Ostrość wykonany przez wszystkie biorące udział w walce postacie. Walkę zaczyna wtedy ta strona sporu w której padł najniższy wynik.
                Gap może określić też inicjatywę grupy przeciwników jedną kością lub <Ref>stopniem łatwości</Ref> by przyśpieszyć rozgrywkę.
            </Article.Body>

            <Article.Title>
                Punkty życia
            </Article.Title>
            <Article.Body>
                Jeśli punkty życia postaci spadną do zera postać pada nieprzytomna na ziemię i zyskuje <Ref subject="fall">punkty Upadku</Ref>.
                Przytomność wraz z 1 punktem życia odyska dopiero gdy jej sojusznicy wygrają walkę, lub zostanie jej udzilona pomoc.
            </Article.Body>

            <Article.SubTitle>
                Stan zdrowia
            </Article.SubTitle>
            <Article.Body>
                W zależności od ilości posiadanych punktów życia postać zdobywa stan:
                <Table aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell style={{ fontWeight: 'bold' }}>Stan</TableCell>
                            <TableCell style={{ fontWeight: 'bold' }}>Aktualne życie</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow key={0}>
                            <TableCell>Zdrowy</TableCell>
                            <TableCell>30 i powyżej </TableCell>
                        </TableRow>
                        <TableRow key={1}>
                            <TableCell>Lekko ranny</TableCell>
                            <TableCell>poniżej 30</TableCell>
                        </TableRow>
                        <TableRow key={2}>
                            <TableCell>Ranny</TableCell>
                            <TableCell>poniżej 20</TableCell>
                        </TableRow>
                        <TableRow key={3}>
                            <TableCell>Ciężko ranny</TableCell>
                            <TableCell>poniżej 10</TableCell>
                        </TableRow>
                        <TableRow key={0}>
                            <TableCell>Nieprzytomny</TableCell>
                            <TableCell>0</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </Article.Body>

            <Article.Title> Akcje i Wtrącenia</Article.Title>
            <Article.Body>
                Podczas swojej tury możesz wykonać różne czynności, ale niektóre z nich zajmują więcej czasu, a inne mniej. Gap oceni, czy Twoje działania zmieszczą się w jednej turze.

                Niektóre czynności są przypisane do tzw. Akcji. Oznacza to, że możesz wykonać tylko jedną Akcję w każdej turze. Przykładami Akcji są: atak, użycie umiejętności czy interakcje wymagające rzutu.
                Jeśli czynność ma mały wpływ na przebieg sytuacji, Gap może zgodzić się na dodatkową Akcję w turze.

                Innym rodzajem czynności są Wtrącenia. To szybkie działania, które możesz wykonać zarówno w swojej turze, jak i w turze przeciwników, w odpowiedzi na ich ruchy.
                Możesz użyć tylko jednego Wtrącenia pomiędzy swoimi turami. Oznacza to, że możesz zdecydować, czy chcesz wykorzystać Wtrącenie w turze przeciwnika, czy poczekać i użyć go w swojej turze.
            </Article.Body>

            <Article.Title> Atak i obrażenia</Article.Title>
            <Article.Body>
                Test na atak fizyczny wykonuje się gdy chcesz trafić przeciwnika, np. uderzyć go mieczem, trafić z łuku, lub dotknąć w trakcie walki.

                Aby wykonać atak fizyczny, wykonaj rzut sporny Twój <Ref>Atak</Ref> przeciwko <Ref>Obronie</Ref> przeciwnika.
                Jeśli wygrałeś, trafiasz i zadajesz obrażenia równe <Ref>stopniowi sukcesu</Ref> oraz dodajesz obrażenia od broni/zdolności.

                Jeżeli do manipulowania bronią używasz siły woli w teście ataku użyj <Ref>Ducha</Ref> zamiast <Ref>Ataku</Ref>
            </Article.Body>

            <Article.Title>Obrona</Article.Title>
            <Article.Body>
                Obrona to kość używana przy odpieraniu ataku i jest równa K20. Żeby zwiększyć swoją obronę możesz użyć <Ref>Uniku</Ref> lub <Ref>Bloku</Ref>.
            </Article.Body>

            <Article.SubTitle>Unik</Article.SubTitle>
            <Article.Body>
                Gdy jesteś celem ataku lub ataków jednego przeciwnika możesz wykorzystać wtrącenie by wykonać Unik, jako kość obrony wykorzystujesz wtedy kość ostrości przeciwko wszystkim atakom jednego wroga.
            </Article.Body>

            <Article.SubTitle>Blok</Article.SubTitle>
            <Article.Body>
                Do wykonania Bloku wymagany jest przedmiot lub umiejętność posiadający opcje <Ref>Blok</Ref>. Blok działa identycznie jak Unik ale kość Obrony wynika w tym przypadku ze statystyk przedmiotu/umiejetności.
                Podobnie jak w przypadku Uniku Blok to Wtrącenie i pozwala na Bloki wielu ataków jednej postaci.
                {/* Postać która ma niski unik a chciałaby zwiększyc swoją obronę może uzyć tarczy */}
            </Article.Body>

            <Article.Title> Rodzaje obrażeń </Article.Title>
            <Article.Body>
                Istnieją 3 rodzaje obrażeń <Ref>fizyczne</Ref>, <Ref>niefizyczne</Ref> oraz <Ref>niechybne</Ref> Rodzaj
                zadawanych obrażeń wynika z opisu broni, zdolności lub przedmiotu.
                Obrażenia fizyczne redukowane są przez pancerz a niefizyczne przez obronę niefizyczną.
                Obrażenia niechybne natomiast nie można zredukować.
            </Article.Body>

            <Article.Title> Walka dwiema broniami </Article.Title>
            <Article.Body>
                Jeżeli walczysz dwiema broniami Twoja kość ataku zostaje ulepszona o 1, ale przy ataku możesz wykorzystać obrażenia i zdolności tylko jedenej z trzymanych broni.
            </Article.Body>

            <Article.Title>
                Dekoncentracja
            </Article.Title>
            <Article.Body>
                Jako akcja podcza walki możesz podjąc próbę dekoncentracji przeciwnika. Wykonaj rzut sporny na <Ref>Ducha</Ref>.
                Przy sukcesie przeciwnik zostaje zdekoncentrowany(ma obniżony Atak i Obronę o 1), przy conajmniej 5 stopniach sukcesu przeciwnik dodatkowo traci swoją nastepną turę.
            </Article.Body>

            <Article.Title>
                Pomoc w walce
            </Article.Title>
            <Article.Body>
                Jako akcja podczas walki możesz pomagać swoim towarzyszom, aby otrzymali skupienie kości podczas ich akcji.
            </Article.Body>

            <Article.Title>
                Rynsztunek
            </Article.Title>
            <Article.Body>
                Rynsztunek to wszystkie przedmioty jakie masz na sobie w trakcie walki. Są to:
                <ul>
                    <li>przedmioty trzymane w rekach</li>
                    <li>pancerz</li>
                    <li>jeden przedmiot pod ręką - np. przy pasie czy w dedykowanej kieszeni.</li>
                </ul>
                <p>Żeby nosić przedmioty musisz spełniać ich wymagania.</p>
            </Article.Body>

            <Article.Title>
                Rodzaje i cena przedmiotów
            </Article.Title>
            <Article.Body>
                Istnieją 3 stopnie jakości przedmiotów wchodzących w skład rynsztunku im lepsza jakość tym lepszy i droższy jest przedmiot.
                <Table aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell style={{ fontWeight: 'bold' }}>Jakość</TableCell>
                            <TableCell style={{ fontWeight: 'bold' }}>Cena</TableCell>
                            <TableCell style={{ fontWeight: 'bold' }}>Ilość ulepszeń</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow key={0}>
                            <TableCell>Standardowa</TableCell>
                            <TableCell>około 10 UniC</TableCell>
                            <TableCell>1</TableCell>
                        </TableRow>
                        <TableRow key={1}>
                            <TableCell>Dobra</TableCell>
                            <TableCell>około 100 UniC</TableCell>
                            <TableCell>2</TableCell>
                        </TableRow>
                        <TableRow key={2}>
                            <TableCell>Świetna</TableCell>
                            <TableCell>około 1000 UniC</TableCell>
                            <TableCell>3</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
                Przedmioty dwuręczne kosztują podwójnie i mają dwa razy więcej ulepszeń
            </Article.Body>

            <Article.Title>
                Zbroja
            </Article.Title>
            <Article.Body>
                Ulepszenia:
                <ul>
                    <li>Twarda - +1 do Pancerza</li>
                    <li>Tłumienie - +1 do Odporności</li>
                    <li>Podbita - +5 do Życia</li>
                    <li>Ciernie - Zbroja obija zablokowane obrażenia w napastnika jako obrażenia niechybne</li>
                    <li>Premia Startowa -  W pierwszej turze walki masz dodatkowe 3 punkty pancerza</li>
                    <li>Lekka - Możesz wykonać dwa Uniki w turze, jeśli masz jedną rękę wolną</li>
                    <li>Wygodna - Skupienie Uników</li>
                    <li>Regeneracja - Na początku Twojej tury regenerujesz jeden punkt życia</li>
                    <li>Kieszeń - Dodatkowe miejsce na przedmiot pod ręką</li>
                    <li>Komuflarz - zapewnia dodatkową turę przed walką jeśli walka odbywa się w zacienieniu</li>
                </ul>
            </Article.Body>

            <Article.Title>
                Przedmioty do noszenia w drugiej ręce
            </Article.Title>
            <Article.Body>
                Ulepszenia:
                <ul>
                    <li>Blok - umożliwia wykonanie Bloku K12, K10 przy 2 i K8 przy 3 ulepszeniach</li>
                    <li>Blask - Emituje światło</li>
                    <li>Ciernie - Odbija 1 punkt otrzymanych obrażeń</li>
                    <li>Roztrzaskanie - Gdy stracisz pierwsze 10 punktów życia podczas walki, tarcza emituje energię zadającą obrażenia niefizyczne (Rzut przeciwstawny na Duszę)</li>
                    <li>Utwardzenie - (Akcja) zwiększasz swój pancerz o 2 do końca tury</li>
                    <li>Puklerz - Przedmiot nie zajmuje ręki, nadal masz <Ref>Wolną dłoń</Ref></li>
                    <li>Lekka - Pierwsze użycie Bloku nie wymaga Wtrącenia</li>
                </ul>
            </Article.Body>

            <Article.Title>
                Broń
            </Article.Title>
            <Article.Body>
                Ulepszenia
                <ul>
                    <li>Ciężka - +2 do obrażeń</li>
                    <li>Finezyjna - Przy trafieniu krytycznym wykonujesz drugi atak</li>
                    <li>Precyzyjna - Trafiasz krytycznie na wynikach większych o 1. (czyli np: na 1, 2, 3 jeśli wybrałeś tą opcje dwa razy)</li>
                    <li>Nieuchronny cios - Trafienia krytyczne są niechybne</li>
                    <li>Obuchowa - Przy trafieniu krytycznym zadajesz dodatkowe 4 obrażenia</li>
                    <li>Ostra - Trafienia bronią wywołują krwawienie 1</li>
                    <li>Kolce - Chybione ataki zadają 1 obrażenie niechybne</li>
                    <li>Ból - Trafienia krytyczne wywołują ból, przeciwnik rzuca na utratę Determinacji</li>
                    <li>Wyważona - Podczas używania tej broni dwuręcznej nadal masz 1 <Ref>Wolną rękę</Ref></li>
                    <li>Przywołanie - (Akcja) broń wraca do Twojej ręki</li>
                    <li>Skrytubójcza - Pierwszy atak tej broni w walce zadaje obrażenia niechybne</li>
                    <li>Niefizyczna - Broń zadaje obrażenia niefizyczne</li>
                    <li>Drzewcowa - (Reakcja) Możesz wykonać atak gdy ktoś wchodzi w zasięg twojego ataku</li>
                </ul>
            </Article.Body>
            {/* amulet - przedmiot, hełm, buty, rekawice, pierścień który dodaje jeszcze jakieś opcje. np. magic find - itp */}
            <Article.Title>
                Przedmioty podręczne
            </Article.Title>
            <Article.Body>
                <TableContainer component={Paper}>
                    <Table aria-label="simple table">
                        <TableHead>
                            <TableRow style={{ maxWidth: '100px' }}>
                                <TableCell width={20}  style={{ fontWeight: 'bold', maxWidth: '100px' }} colSpan={1}>Nazwa</TableCell>
                                <TableCell width={20}  style={{ fontWeight: 'bold', maxWidth: '100px' }} colSpan={1}>Cena</TableCell>
                                <TableCell align="center" style={{ fontWeight: 'bold', maxWidth: '700px' }} colSpan={3}>Opis</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow key={0} style={{ maxWidth: '100px' }}>
                                <TableCellFixed colSpan={1}>Przedmiot leczący(mały)</TableCellFixed>
                                <TableCellFixed colSpan={1}>50 UniC <br/> (jednorazowy)</TableCellFixed>
                                <TableCellFixed align="center" > (Wtrącenie) przywraca 10 punktów życia</TableCellFixed>
                            </TableRow>
                            <TableRow key={1}>
                                <TableCellFixed colSpan={1}>Przedmiot leczący</TableCellFixed>
                                <TableCellFixed colSpan={1}>100 UniC <br /> (jednorazowy)</TableCellFixed>
                                <TableCellFixed align="center"> (Akcja) przywraca 20 punktów życia</TableCellFixed>
                            </TableRow>
                            <TableRow key={2}>
                                <TableCellFixed colSpan={1}>Przedmiot leczący(duży)</TableCellFixed>
                                <TableCellFixed colSpan={1}>200 UniC <br/> (jednorazowy)</TableCellFixed>
                                <TableCellFixed align="center"> (Akcja) przywraca 50 punktów życia</TableCellFixed>
                            </TableRow>
                            <TableRow key={3}>
                                <TableCellFixed colSpan={1}>Świetlik</TableCellFixed>
                                <TableCellFixed colSpan={1}>20 UinC <br/> (jednorazowy)</TableCellFixed>
                                <TableCellFixed align="center"> (Wtrącenie) wyrzycasz źródło świata, które oświetla jedno pomieszczenie przez 1 godzinę</TableCellFixed>
                            </TableRow>
                            <TableRow key={4}>
                                <TableCellFixed colSpan={1}>Pociski</TableCellFixed>
                                <TableCellFixed colSpan={1}>21 UinC <br/> (7 pocisków)</TableCellFixed>
                                <TableCellFixed align="center">Pociski np. strzały, kamienie lub dodatkowy magazynek</TableCellFixed>
                            </TableRow>
                            <TableRow key={5}>
                                <TableCellFixed colSpan={1}>Świetlik</TableCellFixed>
                                <TableCellFixed colSpan={1}>20 UinC <br/> (jednorazowy)</TableCellFixed>
                                <TableCellFixed align="center">(Wtrącenie) wyrzycasz źródło świata, które oświetla jedno pomieszczenie przez 1 godzinę</TableCellFixed>
                            </TableRow>
                            <TableRow key={6}>
                                <TableCellFixed colSpan={1}>Ulepszenie do broni</TableCellFixed>
                                <TableCellFixed colSpan={1}>50 UniC <br/> (jednorazowy)</TableCellFixed>                                
                                <TableCellFixed align="center">(Wtrącenie) Zwiększa obrażenia broni o 2 na 3 kolejne ataki.</TableCellFixed>
                            </TableRow>
                            <TableRow key={7}>
                                <TableCellFixed colSpan={1}>Ulepszenie do broni</TableCellFixed>
                                <TableCellFixed colSpan={1}>50 UniC <br/> (jednorazowy) </TableCellFixed>                                
                                <TableCellFixed align="center"> (Wtrącenie) Zwiększa obrażenia broni o 2 na 3 kolejne ataki.</TableCellFixed>
                            </TableRow>
                            <TableRow key={8}>
                                <TableCellFixed colSpan={1}>Broń do rzucania</TableCellFixed> 
                                <TableCellFixed colSpan={1}>60 UniC <br/> (3 sztuki)</TableCellFixed>                               
                                <TableCellFixed align="center">(Akcja) Wykonujesz atak dystansowy bronią 3 dmg.</TableCellFixed>
                            </TableRow>
                            <TableRow key={9}>
                                <TableCellFixed colSpan={1}>Lekka broń do rzucania</TableCellFixed>                                
                                <TableCellFixed colSpan={1}>25 UniC <br/> (5 sztuk)</TableCellFixed>
                                <TableCellFixed align="center">(Wtrącenie) Wykonujesz atak dystansowy bronią 0 dmg.</TableCellFixed>
                            </TableRow>
                            <TableRow key={10}>
                                <TableCellFixed colSpan={1}>Lekka broń do rzucania</TableCellFixed>                                
                                <TableCellFixed colSpan={1}>25 UniC <br/> (5 sztuk)</TableCellFixed>
                                <TableCellFixed align="center">(Wtrącenie) Wykonujesz atak dystansowy bronią 0 dmg.</TableCellFixed>
                            </TableRow>
                            <TableRow key={11}>
                                <TableCellFixed colSpan={1}>Kolczatki/olej/kulki</TableCellFixed>                                
                                <TableCellFixed colSpan={1}>20 UniC <br/> (jednorazowy)</TableCellFixed>
                                <TableCellFixed align="center">(Wtrącenie) wyrzucasz koczatki utrudniające ruch na danym obszarze.  </TableCellFixed>
                            </TableRow>
                            <TableRow key={12}>
                                <TableCellFixed colSpan={1}>Bomba dymna/ błyskowa</TableCellFixed>                                
                                <TableCellFixed colSpan={1}>25 UniC <br/>  (jednorazowy)</TableCellFixed>
                                <TableCellFixed align="center"> (Wtrącenie) wyrzucasz bombę która ogranicza widoczność. </TableCellFixed>
                            </TableRow>
                            <TableRow key={13}>
                                <TableCellFixed colSpan={1}>Granat/bomba</TableCellFixed>     
                                <TableCellFixed colSpan={1}>25 UniC <br/> (jednorazowy) </TableCellFixed>                           
                                <TableCellFixed align="center"> (Akcja) Wyrzucasz granat zadający obrażenia fizyczne wszystkim postaciom na obszarze 25 metrów.
                                    Wykonaj atak sporny na ostrość, w przypadku powodzenia granat zadaje 30 obrażeń fizycznych </TableCellFixed>
                            </TableRow>
                            <TableRow key={14}>
                                <TableCellFixed colSpan={1}>Umiejętność w przedmiocie</TableCellFixed>                                
                                <TableCellFixed colSpan={1}>100 UniC <br/> (jednorazowy) Przedmiot leczący</TableCellFixed>
                                <TableCellFixed align="center">  Przedmiot umozliwia jednorazowe użycie jednej umiejętności (poziom podstawowy). </TableCellFixed>
                            </TableRow>
                            <TableRow key={15}>
                                <TableCellFixed colSpan={1}>Druga broń</TableCellFixed>       
                                <TableCellFixed colSpan={1}>Przedmiot leczący</TableCellFixed>                     
                                <TableCellFixed align="center">(Wtrącenie) Możesz zmienić jeden trzymany przedmiot w trakcie walki jeśli masz do podręką. </TableCellFixed>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </Article.Body>
        </>
    )
}
